<script>
import BaseResource from '@/resources'

export default {
    components: {},
    props: {
        to: {
            required: true,
            type: Function
        },
        filter: {
            required: false,
            type: Function
        },
        value: {
            validator(value) {
                return value && (value instanceof BaseResource) || ['number', 'string'].includes(typeof value)
            }
        },
        state: {
            type: [Boolean, null],
            default: null
        },
        required: Boolean,
        placeholder: String,
        primaryKey: Boolean,
        description: String,
        addonForced: Boolean,
    },
    computed: {},
    watch: {
        search() {
            if (this.searchDebounceInterval) {
                clearTimeout(this.searchDebounceInterval)
            }

            this.searchDebounceInterval = setTimeout(() => this.searchResources(), 600)
        },
        selectedResource() {
            clearTimeout(this.searchDebounceInterval)
            const value = (this.primaryKey) ? this.selectedResource?.id : this.selectedResource
            this.$emit('input', value || null)
        },
        async value() {
            if (this.value) {
                this.selectedResource = (this.primaryKey) ? await this.to.detail(this.value) : this.value
                this.search = String(this.selectedResource)
            } else {
                this.selectedResource = null
                this.search = ''
            }
        },
    },
    data() {
        return {
            loading: false,
            search: (this.value) ? String(this.value) : '',
            searchDebounceInterval: null,
            searchResultsVisible: false,
            searchResults: [],
            selectedResource: this.value || null
        }
    },
    methods: {
        async searchResources() {
            this.searchResultsVisible = false
            this.selectedResource = null
            const userFilters = ('function' === typeof this.filter) ? this.filter(this.search) : {}

            const filters = Object.assign({
                search: this.search
            }, userFilters)

            const page = await this.to.filter(filters)
            this.searchResults = page.resources
            this.searchResultsVisible = true
        },
        async searchResourcesOnSelect(resource) {
            this.selectedResource = resource
            this.search = (!resource) ? '' : String(resource)
            this.$nextTick(() => this.searchResultsVisible = false)
        },
        async searchResourcesOnBlur() {
            setTimeout(() => this.searchResultsVisible = false, 500)
        },
        searchClear() {
            this.search = ''
            this.selectedResource = null
        },
        onKeydown(e) {
            if (e.key.toLowerCase() === 'enter' && this.searchResultsVisible && this.searchResults.length > 0) {
                this.searchResourcesOnSelect(this.searchResults[0])
                this.searchResultsVisible = false
                this.$refs.searchInput.blur()
            }
        },
        onClick() {
            console.log('sdf')
        }
    },
    async mounted() {
        if (this.primaryKey && this.value) {
            this.loading = true
            this.selectedResource = await this.to.detail(this.value)
            this.search = String(this.selectedResource)
            this.loading = false
        }
    }
}
</script>

<template>
    <b-input-group :class="{ 'resource-search': true, 'expanded': searchResultsVisible }">
        <b-form-input
            v-model="search"
            @focus="searchResources()"
            @blur="searchResourcesOnBlur()"
            @keydown="onKeydown"
            :disabled="!!selectedResource"
            :state="state"
            autocomplete="off"
            ref="searchInput"
            :placeholder="placeholder">
        </b-form-input>
        <slot name="addons">
            <b-input-group-addon append is-text v-if="selectedResource || addonForced">
                <slot name="addon" :searchClear="searchClear">
                    <b-link @click="searchClear()"><b-icon icon="x" /></b-link>
                </slot>
            </b-input-group-addon>
        </slot>
        <div class="resource-search-results" v-if="searchResultsVisible">
            <ul class="resource-search-results-items" v-if="searchResults.length > 0">
                <li v-for="(result, i) in searchResults" :key="i"><a href="javascript:{}" @click="searchResourcesOnSelect(result)">{{ result }}</a></li>
            </ul>
            <p v-else class="text-muted mb-0 text-center my-3">Aucun résultat trouvé</p>
        </div>
    </b-input-group>
</template>

<style lang="scss" scoped>
.resource-search {
    position: relative;

    .resource-search-results {
        position: absolute;
        z-index: 1000;
        background: #fff;
        width: 100%;
        border: 1px solid #ced4da;
        top: 100%;
        max-height: 300px;
        overflow-y: scroll;

        ul.resource-search-results-items {
            list-style: none;
            padding: 0;
            
            li {
                display: block;

                a {
                    display: block;
                    padding: 0.6rem 0.6rem;
                    color: #000;

                    &:last-child {
                        padding-bottom: 0;
                    }
                }

                &:hover {
                    background-color: #000;
                    color: #fff;

                    a {
                        color: #fff;
                    }
                }

                &:last-child {
                    padding-bottom: 0;
                }
            }
        }
    }
}
</style>
